export default __webpack_public_path__ + "static/media/Wrath of Xotli.bd7e69b1.jpg";